import { render, staticRenderFns } from "./AudioGallery.vue?vue&type=template&id=4d812516&"
import script from "./AudioGallery.vue?vue&type=script&lang=js&"
export * from "./AudioGallery.vue?vue&type=script&lang=js&"
import style0 from "./AudioGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports